// extracted by mini-css-extract-plugin
export var createdDate = "_nn-1";
export var divider = "_nn-2";
export var headerDivider = "_nn-3";
export var messagesCard = "_nn-0";
export var messagesContainer = "_nn-6";
export var messagesContainerWrapper = "_nn-4";
export var showLeftPanelButton = "_nn-8";
export var topButtons = "_nn-7";
export var withPadding = "_nn-5";